import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
} from '@angular/core';
import { IonHeader } from '@ionic/angular/standalone';
import { DeviceState } from 'src/app/store/device/device.state';
import { CommonModule } from '@angular/common';
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IonHeader, CommonModule],
  host: {
    style: 'display: contents',
  },
})
export class HeaderComponent {
  readonly minHeight = input<string | undefined>(undefined);
  readonly collapse = input<'condense' | undefined>(undefined);
  readonly noPaddingRight = input<boolean>(false);
  readonly transparent = input<boolean>(false);

  readonly deviceState = inject(DeviceState);

  /** Whether the screen is smaller than the medium breakpoint. */
  readonly isSmallScreen = this.deviceState.isSmallScreen;
}
